// extracted by mini-css-extract-plugin
export default {"chip":"fNAl2r","interactive":"E9Ey9V","chip-button":"ZwRkRV","account-menu-chip":"ZyMvkU"};